import ItemBaseController from '../common/item.base.controller'

class itemallController extends ItemBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, ItemService, $translate, $stateParams, Navigation) {
    super(Auth, $state, User, ItemService, Modal, $translate, $stateParams, Navigation)

    this.User = User;
    this.$state = $state;
    this.Navigation = Navigation;
    this.hasAcl = {};
    this.model = {
      branchId: this.User.getUser().branchId,
      loggedInUserId: this.User.getUser().id,
      itemsObj: {
        results: [],
        status: null,
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        loading: false,
        searchText: null,
        statusList: [
          { label: 'Checked Out', value: 'checkedOut' },
          { label: 'Checked In', value: 'checkedIn' },
          { label: 'Hold', value: 'hold' },
          { label: 'Deleted', value: 'deleted' },
          { label: 'Lost', value: 'lost' },
        ]
      },
      sortColumn: "assignmentCreatedAt",
      reverseSort: false,
    }
    this.selectedItemStatus = null;
  }

  $onInit() {
    this.loadData();
  }

  sortData = (column) => {
    this.model.reverseSort = (this.model.sortColumn == column) ? !this.model.reverseSort : true;
    this.model.sortColumn = column;
    this.loadData();
  }

  refresh() {
    this.loadData();
  }

  pageChange() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData();
  }

  loadData() {
    this.model.itemsObj.loading = true;
    this.Service.getItemList(this.model.branchId, this.model.itemsObj.searchText,
      this.model.itemsObj.pagination.pageLimit, 
      (this.model.itemsObj.pagination.page - 1) * this.model.itemsObj.pagination.pageLimit,
      this.model.reverseSort, this.model.sortColumn, this.selectedItemStatus)
      .then((data) => {
        this.model.itemsObj.pagination.total = data.total;
        this.model.itemsObj.results = data.results;
        this.totalAssigned = data.totalAssigned;
        this.totalAvailable = data.totalAvailable;
        this.totalCheckout = data.totalCheckout;
        this.totalHold = data.totalHold;
        this.totalLost = data.totalLost;
        this.totalDeleted = data.totalDeleted;
      })
      .catch((err) => {
        this.error = err.message;
      })
      .finally(() => {
        this.model.itemsObj.loading = false;
        setTimeout(() => {
          const el = document.getElementById('itemsSearchText');
          if (el) el.focus();
        }, 100);
      })
  }

  translateStatus(statusCode) {
    return this.$translate.instant('shipment.' + statusCode);
  }

  filterItemView() {
    this.model.itemsObj.pagination.page = 1;
    this.loadData();
  }

  editItems(items) {
    this.$state.go('items.edit', ({
      id: items.itemId,
    }))
  }

  goToUserTab = (userKey) => {
    if (!userKey) return;
    this.Navigation.goToUserTab(userKey, null);
  }

  logisticItemAssign(data) {
    this.Modal.logisticItemAssignModal(data, ({ modal, barcode, routeId, notes, userKey }) => {
      this.model.isAssign = true;
      return this.Service.logisticItemAssign(this.model.branchId, barcode, this.model.loggedInUserId, routeId, notes, true, userKey, data.itemId, 5)
        .then(() => {
          this.resetPage();
          this.loadData();
        })
        .catch(err => {
          this.formatErrorMessage(err);
        })
        .finally(() => {
          this.model.isAssign = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  confirmItemHold(item) {
    this.Modal.confirm({
      header: this.$translate.instant('branch.confirm'),
      message: this.$translate.instant('item.confirm_hold_message', { lable: item.label }),
      callback: (({
        modal
      }) => {
        this.model.isSendToHold = true;
        this.Service.logisticItemHold(this.model.branchId, item.barcode, this.model.loggedInUserId)
          .then(() => {
            this.resetPage();
            this.loadData();
          })
          .catch(err => {
            this.formatErrorMessage(err);
          })
          .finally(() => {
            modal.close();
            this.model.isSendToHold = false;
          })
      }),
      negative: (({
        modal
      }) => {
        modal.close();
      }),
      type: 'danger'
    })
  }


  confirmItemHoldRelease(data) {
    this.Modal.logisticItemHoldReleaseModal(data, ({ modal, barcode, notes }) => {
      this.model.isAssign = true;
      return this.Service.logisticItemHoldRelease(this.model.branchId, barcode, this.model.loggedInUserId, data.routeId, notes)
        .then(() => {
          this.resetPage();
          this.loadData();
        })
        .catch(err => {
          this.formatErrorMessage(err);
        })
        .finally(() => {
          this.model.isAssign = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  confirmItemDelete(item) {
    this.Modal.confirm({
      header: this.$translate.instant('branch.confirm'),
      message: this.$translate.instant('item.confirm_delete_message', { lable: item.label }),
      callback: (({
        modal
      }) => {
        this.model.isDeleting = true;
        this.Service.logisticItemDelete(this.model.branchId, item.barcode, this.model.loggedInUserId)
          .then(() => {
            this.resetPage();
            this.loadData();
          })
          .catch(err => {
            this.formatErrorMessage(err);
          })
          .finally(() => {
            modal.close();
            this.model.isDeleting = false;
          })
      }),
      negative: (({
        modal
      }) => {
        modal.close();
      }),
      type: 'danger'
    })
  }

  confirmItemCheckIn(item) {
    this.Modal.confirm({
      header: this.$translate.instant('branch.confirm'),
      message: this.$translate.instant('item.confirm_check_in_message', { lable: item.label }),
      callback: (({
        modal
      }) => {
        this.model.isDeleting = true;
        this.Service.logisticItemCheckIn(this.model.branchId, item.barcode, this.model.loggedInUserId)
          .then(() => {
            this.resetPage();
            this.loadData();
          })
          .catch(err => {
            this.formatErrorMessage(err);
          })
          .finally(() => {
            modal.close();
            this.model.isDeleting = false;
          })
      }),
      negative: (({
        modal
      }) => {
        modal.close();
      }),
      type: 'danger'
    })
  }

  logisticItemReAssign(data) {
    this.Modal.logisticItemAssignModal(data, ({ modal, barcode, routeId, notes, userKey }) => {
      this.model.isAssign = true;
      return this.Service.logisticItemReAssign(this.model.branchId, barcode, this.model.loggedInUserId, routeId, notes, data.itemAssignmentId, userKey, data.itemId, 5)
        .then(() => {
          this.resetPage();
          this.loadData();
        })
        .catch(err => {
          this.formatErrorMessage(err);
        })
        .finally(() => {
          this.model.isAssign = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  confirmUndoItemAssignment(item) {
    this.Modal.confirm({
      header: this.$translate.instant('branch.confirm'),
      message: this.$translate.instant('item.confirm_undo_item_assignment_warning'),
      callback: (({
        modal
      }) => {
        this.model.undoItemAssignment = true;
        this.Service.undoItemAssignment(this.model.branchId, item.barcode, this.model.loggedInUserId, item.routeId, item.itemAssignmentId, item.userKey, item.itemId, 6)
          .then(() => {
            this.resetPage();
            this.loadData();
          })
          .catch(err => {
            this.formatErrorMessage(err);
          })
          .finally(() => {
            modal.close();
            this.model.undoItemAssignment = false;
          })
      }),
      negative: (({
        modal
      }) => {
        modal.close();
      }),
      type: 'danger'
    })
  }

  formatErrorMessage(err) {
    const errorPrefix = err.data.message.length === 5 ? 'error.' : '';
    this.Modal.errorModal(errorPrefix + err.data.message);
  }

  itemHistory(item) {
    this.Modal.itemHistory(item, ({ modal }) => {
      // modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  filterRecords(value) {
    this.model.itemsObj.pagination.page = 1;
    this.selectedItemStatus = this.selectedItemStatus === value ? undefined : value;
    document.getElementById(value).blur();
    this.loadData();
  }

  confirmItemLost(item) {
    this.Modal.confirm({
      header: this.$translate.instant('branch.confirm'),
      message: this.$translate.instant('item.confirm_lost_message', { lable: item.label }),
      callback: (({
        modal
      }) => {
        this.model.isLost = true;
        this.Service.logisticItemLost(this.model.branchId, item.barcode, this.model.loggedInUserId, item.itemId, 7, item.routeId, item.userKey)
          .then(() => {
            this.resetPage();
            this.loadData();
          })
          .catch(err => {
            this.formatErrorMessage(err);
          })
          .finally(() => {
            modal.close();
            this.model.isLost = false;
          })
      }),
      negative: (({
        modal
      }) => {
        modal.close();
      }),
      type: 'danger'
    })
  }

  confirmItemReturnToAvailable(item) {
    this.Modal.confirmSupervisor('return-item-available', null, ({ modal, supId }) => {
      this.model.isReturnAvailable = true;
      this.Service.logisticItemReturnAvailable(this.model.branchId, item.barcode, supId, item.itemId, 9, item.routeId, item.userKey)
        .then(() => {
          this.resetPage();
          this.loadData();
        })
        .catch(err => {
          this.formatErrorMessage(err);
        })
        .finally(() => {
          modal.close();
          this.model.isReturnAvailable = false;
        });
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  resetPage() {
    this.model.itemsObj.pagination.page = 1;
  }
}

export default itemallController;


// WEBPACK FOOTER //
// ./client/app/components/item/all/item.all.controller.js